import React from "react";

import { Svg } from "../Svg";

import styles from "./LocationListItem.module.scss";

export const getGlyph = (index: number) => {
    return `${index + 1}`;
};

export const IndexGlyph = (props: { index: number; pinClassName?: string }) => {
    return (
        <p className={styles.glyph}>
            <Svg
                name="map-pin"
                className={props.pinClassName ?? styles.pin}
                aria-hidden="true"
            />
            {getGlyph(props.index)}
        </p>
    );
};
